import React from 'react';
import { Field, Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { enviaFormRequest } from '@store/user/actions';
import { Button, Toggler, Tooltip } from '@components';

import { AutopatrocinioInitialValues, AutopatrocinioSchema } from '@schemas';

export const AutopatrocinioB = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>

        <p className="mb-4">
          Venho, por meio deste, exercer a opção pelo Autopatrocínio, me
          comprometendo a recolher mensalmente à Entidade o valor das
          Contribuições do participante e da Patrocinadora, a Despesa
          Administrativa e, quando houver, a Contribuição de Risco para
          assegurar a percepção dos benefícios conforme previsto no Regulamento
          do Plano Misto de Benefícios Previdenciários da Forluz (Plano B),
          sujeitando-me, em caso de não cumprimento dessa obrigação às
          penalidades previstas no Regulamento.
          <Tooltip title="Instituto que faculta o participante a continuar contribuindo para o plano previdenciário, retroativamente à data do desligamento da Patrocinadora, assumindo as contribuições individual e patronal mais a taxa administrativa, que é apurada anualmente com base no saldo da conta de aposentadoria. O cálculo da contribuição mensal como autopatrocinado é sobre o último salário real de contribuição em atividade, atualizado anualmente pelo Índice Atuarial do Plano (IPCA-IBGE). Ao optar pelo autopatrocínio o participante permanecerá com o nível de contribuição atual podendo alterar o percentual de contribuição e o perfil de investimento de acordo com as regras vigentes e até mesmo suspender as contribuições temporariamente. A opção pelo autopatrocínio possibilita posterior opção pelo BPD, Portabilidade ou Resgate.">
            ?
          </Tooltip>
        </p>
        <Formik
          validateOnMount
          initialValues={AutopatrocinioInitialValues}
          validationSchema={AutopatrocinioSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => {
            return (
              <Form>
                <div className="row">
                  <Field
                    name="aceite"
                    component={Toggler}
                    label="Declaro estar ciente de que as contribuições vertidas ao Plano de Benefício serão entendidas como contribuição do participante."
                  />
                </div>
                <hr className="mt-32 mt-xs-0 mb-32" />
                <div className="row">
                  <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                    <div className="d-block d-md-flex align-items-center">
                      <Button
                        disabled={!isValid}
                        className="ms-0 ms-md-3"
                        onClick={handleSubmit}
                      >
                        Continuar
                      </Button>
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};
